<template>
  <div class="sf-full-width">
    <div class="sf-empty-state">
      <img
        class="sf-empty-state-image"
        :src="$imagesRequire(imageSrc)"
        :style="maxImageWidth ? { maxWidth: maxImageWidth } : {}"
      />
      <div v-if="title" class="sf-empty-state-title sf-c-text">
        {{ title }}
      </div>
      <div class="sf-empty-state-text sf-c-text">
        {{ text }}
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: 'empty_states/communication.svg',
    },
    maxImageWidth: {
      type: String,
      default: '',
    },
  },
}
</script>
